import { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import styles from './animation.css';


const Animation = ({
  show,
  animation,
  children,
  overlay,
  className,
}) => {
  const [render, setRender] = useState(show);
  const [content, setContent] = useState(undefined);

  useEffect(() => {
    if (show) setRender(true);
  }, [show]);

  useEffect(() => {
    if (show) setContent(children);
  }, [children]);

  const onAnimationEnd = () => {
    if (!show) {
      setRender(false);
      setContent(undefined);
    }
  };

  const animationClass = (display, anim) => {
    if (display && anim === 'slide_left') return styles.slideIn_left;
    if (!display && anim === 'slide_left') return styles.slideOut_left;
    if (display && anim === 'slide_down') return styles.slideIn_top;
    if (!display && anim === 'slide_down') return styles.slideOut_top;
    return null;
  };

  const overlayAnimation = (display, showOverlay) => {
    if (display && showOverlay) return `${styles.overlay} ${styles.fadeIn}`;
    if (!display && showOverlay) return `${styles.overlay} ${styles.fadeOut}`;
    return null;
  };

  return (
    render ? (
      <>
        {overlay && <div className={`${overlayAnimation(show, overlay)}`} />}
        <div className={`${animationClass(show, animation)} ${className || ''}`} onAnimationEnd={onAnimationEnd}>
          { content }
        </div>
      </>
    ) : <div className={styles.hide} />
  );
};

Animation.propTypes = {
  show: PropTypes.bool.isRequired,
  animation: PropTypes.string,
  children: PropTypes.node.isRequired,
  overlay: PropTypes.bool,
  className: PropTypes.string,
};

export default Animation;
